import { useContext } from 'react';
import { appContext } from '../../../AppContext';

const SelectFilesUpload = ({ handleFileUpload, validateState, files }) => {
  const { uploadLimitReached } = useContext(appContext);
  const hasJsonContent = files.some((file) => 'jsonContent' in file);

  return (
    <div
      className={`w-full flex items-center gap-4 animate-fade-in-first ${
        validateState && 'justify-center'
      }`}
    >
      {!validateState ? (
        <>
          <input
            type="file"
            hidden
            id="browse"
            onChange={handleFileUpload}
            multiple
            disabled={validateState || uploadLimitReached}
          />

          <label
            htmlFor="browse"
            className={`w-10 h-10 text-black flex items-center justify-center rounded-full font-bold text-[30px] 
        
        ${
          uploadLimitReached
            ? 'bg-[grey] cursor-not-allowed'
            : 'bg-minima-orange-2023 cursor-pointer hover:bg-minima-orange-light hover:border-solid transition-all duration-600 ease-linear'
        }
        `}
          >
            +
          </label>
          <div className="flex flex-col items-start">
            <p className={`text-lg font-normal ${uploadLimitReached && ' text-[grey]'}`}>
              {hasJsonContent ? 'Drag and drop one source file' : 'Drag and drop a file'}
            </p>
            <p
              className={`text-sm font-normal
                ${uploadLimitReached ? 'text-[grey]' : 'text-gray-400'}`}
            >
              Or select a file
            </p>
          </div>
        </>
      ) : (
        <p className="text-center text-core-grey-5 text-[22px] font-medium">Verifying data...</p>
      )}
    </div>
  );
};
export default SelectFilesUpload;
